import Feature from 'ol/Feature';
import Geometry from 'ol/geom/Geometry';
import { CoordinatePointModel } from './coordinate-point';
import { ImportCSVTableFieldModel } from './ImportCSV';
import { NavaidModel } from './navaid';
import { ProcedureCoordinatePointModel } from './procedure-coordinate-point';
import { ProcedureLeg } from './procedure-leg';

export interface Procedure {
    id:number,
    name: string,
    aircraftspeed : number,
    freetext : string,
    procedureid : string,
    proceduretype : string,
    referenceAirportPk : number,
    rnavperformancetype : string
}

export class ProcedureModel implements Procedure {
  id:number;
  name: string;
  aircraftspeed : number;
  freetext : string;
  procedureid : string;
  proceduretype : string = "SID";
  referenceAirportPk : number;
  rnavperformancetype : string = "B_RNAV";
  procedureCoordinatePoints: ProcedureCoordinatePointModel[] = [];
  navaids : NavaidModel[] = [];
  criticalNavaids : NavaidModel[] = [];
  procedureLegs: ProcedureLeg[] = [];
  airport: string;
  mapstatus: boolean = true;
  actualLegId: number;
  isselected:boolean = false;
  iDNotEditable? : boolean = false;
  latLonNotEditable? : boolean = false;

  getInformation(){
    let information = "";

    information += '<h4 style="font-weight:bold">Procedure</h4>';
    information += "<p>ID: " + this.procedureid + "</p>";
    information += "<p>Name: " + this.name + "</p>";
    information += "<p>Type: " + this.proceduretype + "</p>";
    information += "<p>Total Points: " + this.procedureCoordinatePoints.length + "</p>";
    information += "<p>Aircraft Speed: " + this.aircraftspeed + "</p>";

    return information;
  }
}

export class ProcedureDTOCalculation{
  type : number;
  rnavType : number;
  waypoints : WaypointsDTOCalculation[] = [];
}

export class WaypointsDTOCalculation{
  id : number;
  identification : string;
  name : string;
  latitude : number;
  longitude : number;
  aircraftheight : number;
  fixpoint: boolean;
}


export class ProcedureCsvModel {
  table : ImportCSVTableFieldModel[] = [];
  dataStartingLine : number = 2;
  fieldSeparator : string = ",";
  decimalSeparator : string = ".";
  file : File;
  fileContent : ProcedureCSVContent[] = [];

  fillTable() : void {
    this.table.push(new ImportCSVTableFieldModel("Sequence Number","A"));
    this.table.push(new ImportCSVTableFieldModel("WPT Type","B"));
    this.table.push(new ImportCSVTableFieldModel("Coordinate Point ID","C"));
    this.table.push(new ImportCSVTableFieldModel("Latitude","D"));
    this.table.push(new ImportCSVTableFieldModel("Longitude","E"));
    this.table.push(new ImportCSVTableFieldModel("Height","F"));
  }

  saveData(): ProcedureCsvModel{
    let newModel : ProcedureCsvModel = new ProcedureCsvModel();
    newModel.dataStartingLine = this.dataStartingLine;
    newModel.fieldSeparator = this.fieldSeparator;
    newModel.decimalSeparator = this.decimalSeparator;
    return newModel;
  }
}


export class ProcedureCSVContent{

  sequenceNumber : string;
  wtpType : string;
  coordinatePointId : string;
  latitude : string;
  longitude : string;
  height : string;

  static map(csvLine: any, table: ImportCSVTableFieldModel[]): ProcedureCSVContent {

    var line : ProcedureCSVContent = new ProcedureCSVContent();
    line.sequenceNumber = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Sequence Number",table))];
    line.wtpType = this.transformWtpType(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("WPT Type",table))]);
    line.coordinatePointId = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Coordinate Point ID",table))];
    line.latitude = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Latitude",table))];
    line.longitude = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Longitude",table))];
    line.height = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Height",table))];
    return line;
  }

  static transformWtpType(element : string) : string{
    switch(element){
      case "F/O":
        return "Fly-Over";
        break;
      case "F/B":
        return "Fly-By";
        break;
      case "DEP":
        return "DEP";
        break;
      case "ENR":
        return "ENR";
        break;
      case "IAWP":
        return "IAWP";
        break;
      case "IAF":
        return "IAF";
        break;
      case "IWP":
        return "IWP";
        break;
      case "IF":
        return "IF";
        break;
      case "FAWP":
        return "FAWP";
        break;
      case "FAF":
        return "FAF";
        break;
      case "LTP":
        return "LTP";
        break;
      case "MAWP":
        return "MAWP";
        break;
      case "MAPt":
        return "MAPt";
        break;
      default:
        return element;
    }
  }
}

export class ProcedureNavaidAssociationModel{
  navaids : NavaidModel[] = [];
  procedures : ProcedureModel[] = [];
  rows : any[] = [];
  columns : ProcedureNavaidAssociationTableColumnModel[] = [];
}

export class ProcedureNavaidAssociationTableColumnModel{
  id: string;
  description: string;

  static transformNavaidInColumnModel(navaid : NavaidModel) : ProcedureNavaidAssociationTableColumnModel {
    let column : ProcedureNavaidAssociationTableColumnModel = new ProcedureNavaidAssociationTableColumnModel();
    column.id = navaid.id;
    column.description = navaid.navaidid;
    return column;
  }
}
